import * as React from 'react';
import { Link } from 'react-router-dom';
import { Groups } from '../../../Enum/Groups';
import { FilterInterface } from '../../../Filter/FilterInterface';
import { RangeFilterValue } from '../../../Filter/RangeFilterValue';
import { ProductInterface } from '../../../Model/Product';
import { FilterService } from '../../../Service/FilterService';
import { Trans } from '../../Trans';
import { AbstractFinder, FinderProps } from '../AbstractFinder';
import { ForceSensorHelper } from './ForceSensorHelper';

export interface ForceSensorFinderProps extends FinderProps {
}

export class ForceSensorFinder extends AbstractFinder<ForceSensorFinderProps> {
    get group(): Groups {
        return Groups.ForceSensor;
    }

    protected renderHeadline(filteredProducts: ProductInterface[], allProducts: ProductInterface[]): JSX.Element {
        return <h1>
            <Link to="/">Home</Link> &gt; <Trans>Kraftaufnehmer</Trans>
        </h1>;
    }

    protected getInitialFilters(): FilterInterface<any>[] {
        return [
            FilterService.callback(
                'Nennkraft',
                RangeFilterValue.empty(),
                ForceSensorHelper.powerFilter,
                false
            ),
            FilterService.callback(
                'Lagerinnendurchmesser',
                RangeFilterValue.empty(),
                ForceSensorHelper.axisDiameterFilter,
                false
            ),
            FilterService.callback(
                'Walzendurchmesser_MW',
                RangeFilterValue.empty(),
                ForceSensorHelper.rollerDiameterFilter,
                false
            ),
            FilterService.callback(
                'Walzenlaenge_MW',
                RangeFilterValue.empty(),
                ForceSensorHelper.rollerLengthFilter,
                false
            ),
            FilterService.equals(
                'Lagerung_Welle',
                '',
                false
            ),
        ];
    }

    protected collectProducts(rootProducts: ProductInterface[]): ProductInterface[] {
        return rootProducts;
    }
}
